import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Dish, CreateDishDto } from 'types';

export const createDish = (data: CreateDishDto): Promise<Dish> => {
  return axios.post('/api/dishes', data);
};

type UseCreateDishOptions = {
  config?: MutationConfig<typeof createDish>;
};

export const useCreateDish = ({ config }: UseCreateDishOptions) => {
  return useMutation({
    onMutate: async (newDish) => {
      await queryClient.cancelQueries(['dishes']);

      const previousDishes = queryClient.getQueryData<Dish[]>(['dishes']);

      queryClient.setQueryData(
        ['dishes'],
        [...(previousDishes || []), newDish]
      );

      return previousDishes;
    },
    onError: (_, __, context: any) => {
      if (context?.previousDishes) {
        queryClient.setQueryData(['dishes'], context.previousDishes);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: createDish,
  });
};
